import React from 'react'
import ReactDOM from 'react-dom'

require('datatables.net-bs')(window, $);
require('datatables.net-buttons.bootstrap')(window, $);
require('datatables.net-buttons.colVis')(window, $);
require('datatables.net-buttons.html5')(window, $);

class Datatable extends React.Component {

  componentDidUpdate(){
    this._datatable();
  }

  _datatable(data) {

    var element = $(ReactDOM.findDOMNode(this));
    var options = this.props.options || {}

    let toolbar = '';
    if (options.buttons)
      toolbar += 'B';
    if (this.props.paginationLength)
      toolbar += 'l';
    if (this.props.columnsHide)
      toolbar += 'C';

    options.data = this.props.data;

    options = _.extend(options, {

      "dom": "<'dt-toolbar'<'col-xs-12 col-sm-6' f><'col-sm-6 col-xs-12 hidden-xs text-right'" + toolbar + ">r>" + "t" + "<'dt-toolbar-footer'<'col-sm-6 col-xs-12 hidden-xs'i><'col-xs-12 col-sm-6'p>>",
      oLanguage: {
        "sSearch": "<span class='input-group-addon input-sm'><i class='glyphicon glyphicon-search'></i></span> ",
        "sLengthMenu": "_MENU_"
      },
      "autoWidth": false,
      retrieve: true,
      responsive: true
    });

    var _dataTable;

    _dataTable = element.find('table').DataTable(options);
    _dataTable.destroy();

    _dataTable = element.find('table').DataTable(options);

    if (this.props.filter) {
      // Apply the filter
      element.find('table').on('keyup change', 'thead th input[type=text]', function() {
        _dataTable.column($(this).parent().index() + ':visible').search(this.value).draw();

      });
    }

  }

  render() {

    let {
      children,
      options,
      ...props
    } = this.props;

    return (
      <div>
        <table {...props}>
          {children}
        </table>
      </div>
    )
  }
}

export default Datatable



// WEBPACK FOOTER //
// ./src/components/tables/Datatable.jsx